module.exports = __webpack_public_path__ + "static/media/message-ongoing.2196b42a.svg";